import "./bookingLoaders.css";

/**
 * Animated truck shedding motion lines. Shown while the booking is finalized
 * and documents are confirmed.
 */
function BookShipmentFinalizingBookingLoading() {
  return <span className="finalizing-booking-loader" />;
}

export default BookShipmentFinalizingBookingLoading;
